import { create } from 'zustand'

interface KPKStore {
  soundPlaying: string | null
  setSoundPlaying: (soundPlaying: string | null) => void
}

export const useKPKStore = create<KPKStore>((set) => ({
  soundPlaying: null,
  setSoundPlaying: (soundPlaying: string | null) => set({ soundPlaying }),
}))
